import React from 'react'

export default function SadFace() {
  return (
    <svg
      fill="#FFFFFF"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 16"
      x="0px"
      y="0px"
    >
      <path
        d="M417,465 L415,465 L415,464.5 C415,463.119288 413.880712,462 412.5,462 C411.119288,462 410,463.119288 410,464.5 L410,465 L408,465 L408,464.5 C408,462.014719 410.014719,460 412.5,460 C414.985281,460 417,462.014719 417,464.5 L417,465 Z M432,465 L430,465 L430,464.5 C430,463.119288 428.880712,462 427.5,462 C426.119288,462 425,463.119288 425,464.5 L425,465 L423,465 L423,464.5 C423,462.014719 425.014719,460 427.5,460 C429.985281,460 432,462.014719 432,464.5 L432,465 Z M416,476 L414,476 C414,472.686292 416.686292,470 420,470 C423.313708,470 426,472.686292 426,476 L424,476 C424,473.790861 422.209139,472 420,472 C417.790861,472 416,473.790861 416,476 Z"
        transform="translate(-408 -460)"
      />
    </svg>
  )
}
